import React, { PureComponent } from 'react';
import Translate from 'react-translate-component';
import PropTypes from 'prop-types';

import TableHeaderResizer from './TableHeaderResizer';
import TableHeaderSort from './TableHeaderSort';

const headerDefaultTemplates = {
    number: '№',
    details: ' ',
    checkbox: ' ',
};

export default class TableHeaderCell extends PureComponent {
    static propTypes = {
        widthStyle: PropTypes.object,
        sort: PropTypes.object,
        column: PropTypes.object.isRequired,
        handleColumnResize: PropTypes.func,
        handleSort: PropTypes.func,
        translation: PropTypes.string
    };

    render() {
        const { column, widthStyle, translation, sort, handleColumnResize, handleSort } = this.props;

        const hasResize = handleColumnResize && !column.noResize;
        const text = headerDefaultTemplates[column.name] || <Translate content={translation}/>;

        return (
            <div style={widthStyle}>
                { column.keySort && (
                    <TableHeaderSort columnName={column.keySort}
                                     sort={sort}
                                     handleSort={handleSort} />
                )}

                { hasResize && (
                    <TableHeaderResizer columnName={column.name}
                                        handleColumnResize={handleColumnResize} />
                )}

                <div className="table-cell-header">
                    {column.label || text}
                </div>
            </div>
        );
    }
}
